import React from 'react';

const ActiveFilters = ({ activeFilters, onRemoveFilter, onClearFilters }) => {
  if (activeFilters.lentgh === 0) return null;

  return (
    <div className="mb-6 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4">
        <div className="flex flex-wrap gap-2 items-center">
          <span className="text-sm font-medium text-slate-600 mr-4">Filtros activos:</span>
          
          {activeFilters.map((filter, index) => (
            <div
              key={index}
              className="inline-flex items-center gap-2 bg-sky-100 text-sky-800 px-4 py-2 rounded-full text-sm font-medium animate-fadeIn"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <span>{filter.label}</span>
              <button
                onClick={() => onRemoveFilter(filter.type)}
                className="ml-1 text-sky-600 hover:text-sky-800 transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          ))}
          
          <button
            onClick={onClearFilters}
            className="text-sm text-slate-500 hover:text-slate-700 font-medium transition-colors duration-200"
          >
            Limpiar todos
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActiveFilters;
